<template lang="html">
  <div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mt-5">
        <vs-input :label="$t('payroll_period') | capitalize" v-model="data.payroll_period" type="number" class="w-full" name="payroll_period" />
      </div>
      <div class="vx-col md:w-1/2 w-full mt-5">
        <vs-input :label="$t('report_csv') | capitalize" v-model="data.report_csv"  type="number" class="w-full" name="report_csv" />
      </div>
      <div class="vx-col md:w-1/2 w-full mt-5">
        <vs-input :label="$t('data_base') | capitalize" v-model="data.data_base" class="w-full" name="data_base"/>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-5">
        <vs-input :label="$t('shelter_fee_min') | capitalize" v-model="data.shelter_fee_min"  type="number" class="w-full" name="shelter_fee_min"/>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-5">
        <vs-input :label="$t('confidentiality') | capitalize" v-model="data.confidentiality" class="w-full" name="confidentiality"/>
      </div>
    </div>
    <div class="vx-row mt-5">
      <div class="vx-col md:w-1/6 w-full mt-5 ml-auto">
        <vs-button color="primary" type="filled" @click="submit" class="w-full" :disabled="disabledSubmit">
          {{ $t('save') | capitalize }}
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    submit() {
      this.$emit('submit', this.data)
    }
  },

  computed: {
    disabledSubmit() {
      return this.data.payroll_period === '' ||
        this.data.report_csv === '' ||
        this.data.data_base === '' ||
        this.data.shelter_fee_min === '' || 
        this.data.shelter_fee_min < 0
    }
  },

  props: {
    data: {
      default: () => ({
        payroll_period: '',
        report_csv: '',
        data_base: '',
        shelter_fee_min: '',
        confidentiality: '',
      })
    },
  }
}
</script>

<style lang="css" scoped>
</style>
